import React from 'react';
import { useDispatch } from 'react-redux';

export const useFetchDLCData = ({ has10DlcFormAccess, fetchDLCForm, customerId }) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (has10DlcFormAccess) {
      dispatch(fetchDLCForm({ customerId }));
    }
  }, [dispatch, customerId, has10DlcFormAccess, fetchDLCForm]);
};
